// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gallery .images{display:grid;column-gap:20px;row-gap:20px;justify-content:center}.gallery .images img{width:100%}@media only screen and (max-width: 599px){.gallery{row-gap:25px}}@media only screen and (min-width: 600px){.gallery{row-gap:25px}}@media only screen and (min-width: 1200px){.gallery{row-gap:70px}}@media only screen and (min-width: 2080px){.gallery .images{max-width:2020px}}\n", ""]);
// Exports
module.exports = exports;
